import { Action, createReducer, on } from '@ngrx/store';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';

import { InterventionContentItem } from '../../../models/intervention-content-item';
import * as interventionContentItemActions from './intervention-content-item.actions';
import { InterventionContentItemOrder } from '../../../models/intervention-content-item-order';

export interface InterventionContentItemState extends EntityState<InterventionContentItem> {
  loadingInterventionContentItems: boolean;
  interventionContentItemsLoaded: boolean;
  contentItemsSortingOrder: InterventionContentItemOrder[];
  selectedInterventionContentItem: InterventionContentItem;
}

export function sortBySortOrder(contentItem1, contentItem2): number {
  return (
    (contentItem1.hasOwnProperty('sortOrder') ? contentItem1.sortOrder : contentItem1?.page?.sortOrder) -
    (contentItem2.hasOwnProperty('sortOrder') ? contentItem2.sortOrder : contentItem2?.page?.sortOrder)
  );
}

export const interventionContentItemAdapter: EntityAdapter<InterventionContentItem> = createEntityAdapter<InterventionContentItem>(
  {
    sortComparer: sortBySortOrder,
  }
);

export const initialInterventionContentItemState: InterventionContentItemState = interventionContentItemAdapter.getInitialState(
  {
    loadingInterventionContentItems: false,
    interventionContentItemsLoaded: false,
    contentItemsSortingOrder: [],
    selectedInterventionContentItem: null,
  }
);

export const reducer = createReducer(
  initialInterventionContentItemState,
  on(interventionContentItemActions.getInterventionContentItemsSuccess, (state, { interventionContentItems }) => {
    return interventionContentItemAdapter.setAll(interventionContentItems, {
      ...state,
      loadingInterventionContentItems: false,
      interventionContentItemsLoaded: true,
      selectedInterventionContentItem: null,
    });
  }),
  on(interventionContentItemActions.addContentItemToInterventionSuccess, (state, { interventionContentItem }) => {
    return interventionContentItemAdapter.addOne(interventionContentItem, {
      ...state,
      selectedInterventionContentItem: interventionContentItem,
    });
  }),
  on(
    interventionContentItemActions.removeContentItemFromInterventionSuccess,
    (state, { deletedItemId, deletedItemType }) => {
      return interventionContentItemAdapter.removeOne(deletedItemId, {
        ...state,
        selectedInterventionContentItem: null,
      });
    }
  ),
  on(interventionContentItemActions.saveContentItemsSortingOrderSuccess, (state, { newSortingOrder }) => {
    return {
      ...state,
      contentItemsSortingOrder: newSortingOrder,
    };
  }),
  on(interventionContentItemActions.addTimingRuleToContentItem, (state, { updatedContentItem }) => {
    return interventionContentItemAdapter.updateOne(
      {
        id: updatedContentItem.id,
        changes: updatedContentItem,
      },
      {
        ...state,
      }
    );
  })
);

export function interventionContentItemReducer(state: InterventionContentItemState | undefined, action: Action) {
  return reducer(state, action);
}

export const { selectIds, selectEntities, selectAll, selectTotal } = interventionContentItemAdapter.getSelectors();
